class ProductSlider extends Component {
	constructor(el) {
		super(el);
		this.swiperEl = this.$find('[data-swiper]');
		this.swiper = null;
		this.swiperEl && this.constructSwiper();
	}

	constructSwiper() {
		this.swiper = new Swiper(this.swiperEl, {
			watchOverflow: true,
			slidesPerView: 2,
			pagination: {
				el: this.swiperEl.querySelector('[data-pagination]'),
				clickable: true,
				lockClass: 'swiper-pagination-lock',
			},
			spaceBetween: 0,
			navigation: {
				nextEl: '[data-prev]',
				prevEl: '[data-next]',
			},
			breakpoints: {
				576: {
					spaceBetween: 12,
				},
				767: {
					slidesPerView: 3,
					spaceBetween: 16,
				},
				1024: {
					slidesPerView: 3,
					spaceBetween: 20,
				},
			}
		});
	}
}